import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import FlowItem from "../components/controls/flowitem";
import JisCheckbox from "../components/controls/jisCheckbox";
import JisButton from "../components/controls/jisButton";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import * as Constants from "../constants";
import "../styles/document_upload.css";
import "../styles/template.css";
import DynamicIcon from "../components/dynamicicon";
import JisDialog from "../components/dialog";
import JisDialogForm from "../components/formdialog";
import PdfViewer from "../components/controls/pdfviewer";
function DocumentUpload() {
  const [caseInfo, setCaseInfo] = useState({});
  const [flow, setFlow] = useState({ pos: 1, code: "doc_type" });
  const [flowerror, setFlowError] = useState("");
  const [option, setOption] = useState("");
  const [uploadtype, setUploadType] = useState(option);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [uploadcode, setUploadCode] = useState(0);

  const navigate = useNavigate();
  const { casefeeid } = useParams();
  const { activePage, token, profile, setIsExpired } = useContext(ShareContext);

  const [eswear, setEswear] = useState(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  //for upload document**************************************

  const [document, setDocuments] = useState({ uplines: [], casedetail: {} });
  const url = `${Constants.apiUrl}/filing/uncompletedUpload/${casefeeid}`;
  const tempUrl = `${Constants.apiUrl}/filing/templates/document`;

  const [selectedItems, setSelectedItems] = useState({});

  const [openTemp, setOpenTemp] = useState(false);

  const [templates, setTemplates] = useState([]);
  const [activeRow, setActiveRow] = useState({});
  const [isPreview, setIsPreview] = useState(false);
  const [previewPath, setPreviewPath] = useState(false);
  const [prevImgs, setPrevImgs] = useState([]);
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "" });
  const [caseDetails, setCaseDetails] = useState({});
  const [openType, setOpenType] = useState(false);
  const [isAttendedTo, setisAttendedTo] = useState(false);
  const [config, setConfig] = useState([]);

  useEffect(() => {
    LoadDocs();
    LoadTemplates();
    onConfig();
  }, []);

  useEffect(() => {
    if (uploadtype == "template") {
      LoadTemplates();
    }
  }, [uploadtype]);

  const onOk = () => {
    setAlert({ ...alert, open: false });
  };

  const onPreview = (obj) => {
    setIsPreview(true);
    setPreviewPath(obj.path);
  };
  const AddWritAdditionalDoc = () => {
    // for saving....
    //adding additional line for Writ of Fifa
    const uplinenew = {
      id: 0,
      docuploadId: document.id,
      documentTitle: "Addional Document",
      gazetteItemId: 0,
    };
    var _uplines = [...document.uplines, uplinenew];
    setDocuments({ ...document, uplines: _uplines });
  };

  const checkUpload = (uploadtype) => {
    const cc = config.find((e) => e.code == uploadtype);
    if (cc != null) {
      return cc.isActive;
    } else {
      return false;
    }
  };

  const handleUploadChange = async (e, rowIndex) => {
    var uline = { ...document[rowIndex] };
    var updatedselectedItems = { ...selectedItems };
    // var updateditems=new Set(items);
    var _uplines = document.uplines;
    setActiveIndex(rowIndex);

    const files = e.target.files;
    console.log(files[0]);
    var b64 = await Constants.toBase64(files[0]);
    var path = URL.createObjectURL(files[0]);
    var fname = Constants.ReduceFilename(files[0]?.name);

    var a = {
      ..._uplines[rowIndex],
      path,
      base64: b64.split(",")[1],
      filename: fname,
      base64Ext: b64.split(",")[0],
    };

    _uplines[rowIndex] = a;

    setDocuments({ ...document, uplines: _uplines });

    console.log(_uplines);
  };

  const LoadDocs = () => {
    setLoading(true);
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setLoading(false);

        if (data.code == 0) {
          setDocuments({ ...data.doc, uplines: data.lines });
          // setUploadType(data.doc1.doctumentType)
          setCaseInfo(data.caseinfo);
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const LoadTemplates = () => {
    // setIsLoading(true);
    fetch(tempUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        //  setIsLoading(false);
        if (data.code == 0) {
          setTemplates(data.templates);
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error(error);
        //setIsLoading(false);
      });
  };
  // console.log(uploadedFiles);

  const onConfig = async () => {
    const urls = `${Constants.apiUrl}/setup/othersettings/upload`;
    console.log(`the calling url ${urls}`);

    try {
      const resp = await fetch(urls, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      setConfig(data);
    } catch (error) {
      console.error(error);
    }
  };
  const onUploadFiles2 = async () => {
    const uploadurl = `${Constants.apiUrl}/filing/uploadDocument/${casefeeid}`;

    const _uplines = document.uplines
      .filter((k) => k.uplineType != null && k.uploadDate == null)
      .map((item) => ({
        id: item.id,
        uplineType: item.uplineType,
        base64: item.base64,
        base64Ext: item.base64Ext,
        templateId: item.templateid,
        templatetitle: item.templatetitle,
        filename: item.filename,
      }));

    const unset = _uplines.filter(
      (k) =>
        (k.uplineType == "template" && k.templateId == null) ||
        (k.uplineType != "template" && k.base64 == null),
    );
    console.log("the file not set at all");
    console.log(unset);
    if (unset.length > 0) {
      // a message should pop up
      setFlowError("Please select the associated file or template");
      return;
    }

    if (_uplines.length == 0) {
      setFlowError(
        "Please set the file upload type and upload the corresponding documents",
      );
      return;
    }

    setFlowError("");

    //loop throu, any type of template must have template id
    //and others must have base6

    // Sending the FormData using fetch
    setLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(_uplines),
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          //saved already
          setOpenDialog(true);
          setUploadCode(data.psastatus);
          setisAttendedTo(data.isAttendedTo);
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  /*   const onPreview= async(id,uline)=>{
        const uploadurl=`${Constants.apiUrl}/gazette/uploadDocument/preview/${id}`
        
      
        var updatedselectedItems={...selectedItems};
       // var updateditems=new Set(items);
            // Sending the FormData using fetch
            setIsLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(uline),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false);
                console.log('preview details');
                console.log(data);
                if(data.code==0){
                    //saved already
                    var updated={...uline,prev:data}
                    updatedselectedItems[id] = updated;
                    setSelectedItems(updatedselectedItems);
                    
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setIsLoading(false);
        });
    } */

  const onDeleteItem = (id) => {
    var updatedselectedItems = { ...selectedItems };
    delete updatedselectedItems[id];
    setSelectedItems(updatedselectedItems);
  };

  const onOpenTemp = (item, ind) => {
    setOpenTemp(true);
    setActiveRow(item);
    setActiveIndex(ind);
  };
  const onCloseTemp = () => {
    setOpenTemp(false);
  };

  const onOpenType = (item, ind) => {
    //to reset any setting
    setOpenType(true);
    setActiveRow(item);
    setActiveIndex(ind);
  };
  /*  useEffect(() => {
       if(!(activeIndex=-1)){
        //reset the active data set
        var _active={...activeRow};
        
       }
       
      }, [option]) */

  const onCloseType = (item) => {
    setOpenType(false);
  };

  const onSelectTemplate = (selected) => {
    var _uplines = document.uplines;
    var a = {
      ..._uplines[activeIndex],
      templateid: selected.id,
      templatetitle: selected.title,
    };

    _uplines[activeIndex] = a;
    setDocuments({ ...document, uplines: _uplines });

    onCloseTemp();
  };

  const onChangeType = () => {
    //set the option value and use it to update the list,

    var _uplines = document.uplines;
    var single = {
      ..._uplines[activeIndex],
      uplineType: option,
      base64: null,
      filename: null,
      templateid: null,
    };
    _uplines[activeIndex] = single;
    setDocuments({ ...document, uplines: _uplines });
    setOpenType(false);
  };

  const onSave = () => {
    // for saving....
  };
  console.log(caseInfo);
  return (
    <div>
      <h4>Document upload</h4>
      <div style={{ textAlign: "left" }}>
        <h4>{caseInfo?.caseTitle?.toUpperCase()}</h4>
        <h4>{caseInfo?.caseNumber || caseInfo?.referenceNumber}</h4>
      </div>
      <div>
        <div className="view">
          <div>
            {/* <div class="section-cases">
                    <span>Documents upload from Gazette Selection</span>
                    </div> */}
            <div className="table-header">
              <p>Pending Uploads</p>
            </div>
            <div>
              <div className="table-wrapper ">
                <table className="case-details-table full-border">
                  <thead>
                    <tr>
                      <th className="col-id">ID</th>
                      <th className="col-title">Document Title</th>
                      {/* <th>Document Count</th> */}
                      {/* <th>Status</th> */}
                      <th className="col-medium">Document Type</th>
                      <th className="col-action">Action</th>
                      {/* <th></th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {document?.uplines.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {casefeeid && item.docUploadId && item.id
                              ? `${casefeeid}/${item.docUploadId}/${item.id}`
                              : "N/A"}
                          </td>
                          <td>{item.documentTitle || "N/A"}</td>
                          {/* <td>{item.selectedTemplate}</td> */}

                          {/* <td
                            className={
                              item.uploadDate != null
                                ? "status uploaded"
                                : "status"
                            }
                          >
                            {item.uploadDate != null && " Uploaded"} */}
                          {/*  {item.filename!=null && 'File Selected'} */}
                          {/* </td> */}

                          {/* <td>{(item.uplineType==null) ?<JisButton onClick={()=>onOpenType(item,index)}>Set Type {item.uplineType}</JisButton> :<span>{item.uplineType}</span>}</td> */}
                          {item.uploadDate == null && (
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onOpenType(item, index)}
                              >
                                {" "}
                                {item.uplineType == null
                                  ? "Select Upload Option"
                                  : item.uplineType}
                              </JisButton>
                            </td>
                          )}
                          {/* {item.uploadDate != null && <td></td>} */}

                          {item.uploadDate == null && (
                            <td className="file">
                              {item.uplineType ==
                              null ? null : item.uplineType === "template" ? ( // uplineType is 'template'
                                <div className="btn-upload">
                                  <JisButton
                                    className="black"
                                    onClick={() => onOpenTemp(item, index)}
                                    title={item?.templatetitle}
                                  >
                                    {item?.templatetitle == null
                                      ? "Select Template"
                                      : Constants.ReduceString(
                                          item.templatetitle,
                                          30,
                                        )}
                                  </JisButton>
                                </div>
                              ) : (
                                // uplineType is 'attest' or 'not-attest'
                                (item.uplineType === "attest" ||
                                  item.uplineType === "not-attest") && (
                                  <div className="btn-upload">
                                    <input
                                      type="file"
                                      accept="application/pdf"
                                      id={`file-upload-${index}-${0}`}
                                      onChange={(e) =>
                                        handleUploadChange(e, index)
                                      }
                                    />
                                    <label
                                      htmlFor={`file-upload-${index}-${0}`}
                                      title={item?.filename}
                                    >
                                      {item.path == null
                                        ? "Choose File"
                                        : Constants.ReduceString(
                                            item?.filename,
                                            30,
                                          )}
                                    </label>
                                    {item.path != null && (
                                      <JisButton
                                        onClick={() => onPreview(item)}
                                      >
                                        Preview
                                      </JisButton>
                                    )}
                                  </div>
                                )
                              )}
                            </td>
                          )}
                          {/* {item.uploadDate != null && <td></td>} */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="error-msg">{flowerror}</div>
            {/* <div className="flowbuttongroup">
              <JisButton onClick={onUploadFiles2}>Submit</JisButton>
              </div> */}
            {document.caseType == "writ-of-fifa" && (
              <JisButton onClick={AddWritAdditionalDoc} variant="outline">
                Add Additional documents
              </JisButton>
            )}
            <div className="affidavit-upload-button-container">
              <JisButton onClick={onUploadFiles2}>Submit</JisButton>
            </div>

            {openDialog && (
              <div className={"dialog-box open"}>
                {uploadcode === 0 && (
                  <div className="wrapper">
                    <h3>UPLOAD SUCCESSFUL</h3>
                    <div className="main">
                      <p>
                        The upload was successful; the case will now move to the
                        Process Section Assessor’s queue{" "}
                      </p>
                      <JisButton
                        onClick={() => navigate("/my-cases")}
                        className="red"
                      >
                        My Cases
                      </JisButton>
                    </div>
                  </div>
                )}
                {uploadcode > 0 && isAttendedTo && (
                  <div className="wrapper">
                    <h3>Document(s) Uploaded Successfully!</h3>
                    <div className="main">
                      <p>
                        Your document(s) have been submitted for e-Swearing. The
                        Commissioner for Oath (CFO) will schedule your
                        document(s) for attestation. For document(s) not
                        requiring commissioning, please ensure you Append
                        Signature, Append Seal and Add Date & Timestamp if you
                        have not done so manually. You can do this by clicking
                        the e-Swearing tab.
                      </p>
                      <div className="btns">
                        <JisButton
                          onClick={() => navigate("/e-swearing")}
                          className="red"
                        >
                          e-Swearing
                        </JisButton>
                        <JisButton
                          onClick={() => navigate("/my-cases")}
                          className="red"
                        >
                          My Cases
                        </JisButton>
                      </div>
                    </div>
                  </div>
                )}
                {document.caseType == "writ-of-fifa" && (
                  <div className="main">
                    <p>
                      Please goto eswearing to complete the document for ACR to
                      be able to process it
                    </p>
                    <div className="btns">
                      <JisButton
                        onClick={() => navigate("/e-swearing")}
                        className="red"
                      >
                        e-Swearing{" "}
                      </JisButton>
                    </div>
                  </div>
                )}
                {uploadcode >= 0 && !isAttendedTo && (
                  <div className="wrapper">
                    <h3>UPLOAD IS SUCCESSFUL </h3>
                    <div className="main">
                      <p>
                        Please note some of the documents you have not uploaded
                        will be waiting on your 'Pending upload' side menu, for
                        you to complete. After which the system decides if you
                        are going to eSwearing or going to PSA.
                      </p>
                      <div className="btns">
                        <JisButton
                          onClick={() => navigate("/my-cases")}
                          className="red"
                        >
                          My Cases
                        </JisButton>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {openTemp && (
            <JisDialogForm
              title="Document Template"
              onClose={() => onCloseTemp()}
            >
              <div className="section affidavit-templates-container">
                <h3 className="section-title">Select Document</h3>

                <div className="templates-grid ">
                  {templates.map((item, id) => {
                    return (
                      <div
                        className="template-card case-template-card"
                        key={id}
                        onClick={() => onSelectTemplate(item)}
                        title={item.note}
                      >
                        {/* <h3>{item.title}</h3>
                      <div className="create">
                        <p>Select Template</p>

                        <DynamicIcon iname="circle" />
                      </div>
                      <div className="line"></div> */}
                        <div className="template-info">
                          <div style={{ flexShrink: 0 }}>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.5 18.75C3.09 18.75 2.75 18.41 2.75 18V7C2.75 2.59 4.09 1.25 8.5 1.25H15.5C19.91 1.25 21.25 2.59 21.25 7V17C21.25 17.16 21.25 17.31 21.24 17.47C21.21 17.88 20.84 18.2 20.44 18.17C20.03 18.14 19.71 17.78 19.74 17.37C19.75 17.25 19.75 17.12 19.75 17V7C19.75 3.43 19.08 2.75 15.5 2.75H8.5C4.92 2.75 4.25 3.43 4.25 7V18C4.25 18.41 3.91 18.75 3.5 18.75Z"
                                fill="#292D32"
                              />
                              <path
                                d="M17 22.75H7C4.66 22.75 2.75 20.84 2.75 18.5V17.85C2.75 15.86 4.37 14.25 6.35 14.25H20.5C20.91 14.25 21.25 14.59 21.25 15V18.5C21.25 20.84 19.34 22.75 17 22.75ZM6.35 15.75C5.19 15.75 4.25 16.69 4.25 17.85V18.5C4.25 20.02 5.48 21.25 7 21.25H17C18.52 21.25 19.75 20.02 19.75 18.5V15.75H6.35Z"
                                fill="#292D32"
                              />
                              <path
                                d="M16 7.75H8C7.59 7.75 7.25 7.41 7.25 7C7.25 6.59 7.59 6.25 8 6.25H16C16.41 6.25 16.75 6.59 16.75 7C16.75 7.41 16.41 7.75 16 7.75Z"
                                fill="#292D32"
                              />
                              <path
                                d="M13 11.25H8C7.59 11.25 7.25 10.91 7.25 10.5C7.25 10.09 7.59 9.75 8 9.75H13C13.41 9.75 13.75 10.09 13.75 10.5C13.75 10.91 13.41 11.25 13 11.25Z"
                                fill="#292D32"
                              />
                            </svg>
                          </div>

                          <p className="template-title">{item.title}</p>
                        </div>
                        <button className="select-btn">Select Template</button>
                      </div>
                    );
                  })}
                </div>
              </div>
            </JisDialogForm>
          )}

          {openType && (
            <JisDialogForm
              minWidth="20%"
              title="Document Type"
              onClose={() => onCloseType()}
            >
              <div className="upload-questions">
                <div>
                  <p className="note">
                    Please select the appropriate document upload
                  </p>
                  <div>
                    {checkUpload("direct-upload") && (
                      <JisCheckbox
                        label="I would be submitting document already attested or commissioned"
                        value={option == "attest"}
                        onChange={(e) => setOption(e ? "attest" : "")}
                      />
                    )}

                    {checkUpload("upload-with-com") && (
                      <JisCheckbox
                        label="I would be submitting document that is yet to be attested or commissioned"
                        value={option == "not-attest"}
                        onChange={(e) => setOption(e ? "not-attest" : "")}
                      />
                    )}

                    {checkUpload("upload-template") && (
                      <JisCheckbox
                        label="I would be using template from JIS, creating related document such as writ of summon, originating summon among other document."
                        value={option == "template"}
                        onChange={(e) => setOption(e ? "template" : "")}
                      />
                    )}
                  </div>

                  <div className="flowbuttongroup">
                    <button
                      className="upload-question-action-btn"
                      onClick={onChangeType}
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            </JisDialogForm>
          )}

          {isPreview && (
            <div className={"preview open"} style={{ overflow: "scroll" }}>
              <div className="heading">
                <div>
                  <JisButton icon="close" onClick={() => setIsPreview(false)}>
                    {" "}
                    Close Preview
                  </JisButton>
                </div>
              </div>
              <PdfViewer pdfUrl={previewPath} />

              <div className="date-btns"></div>
            </div>
          )}
        </div>
      </div>
      <BackLoader open={loading} />
    </div>
  );
}

export default DocumentUpload;
